export const APP_ENDPOINTS = {
	HOME: "/",
	ABOUT: "about",
	SERVICES: "services",
	SERVICES_PAGE_TWO: "services-page-2",
	EXPERTISE: "expertise",
	FREELANCERS: "freelancers",
	CONTACT_US: "contact-us",
};
